<div class="table-responsive">
  <ng-container *ngIf="msg.data | guardType: isIBQueued as ib">
    <h6 class="small mb-0">IB Queued Calls</h6>
    <table class="table table-sm table-bordered table-striped extra-small mb-0">
      <thead class="thead-dark">
        <tr>
          <th>Group</th>
          <th class="text-right">Calls</th>
          <th class="text-right">Max Wait</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let call of ib.queueCalls">
          <tr *ngIf="call.group !== 'Total'">
            <td>
              {{ call.group }}
            </td>
            <td class="text-right">{{ call.calls }}</td>
            <td class="text-right">
              {{ call.longestWait }}
            </td>
          </tr>
          <tr *ngIf="call.group === 'Total'" class="table-secondary total-row">
            <td>Total</td>
            <td class="text-right">
              {{ call.calls }}
            </td>
            <td class="text-right">
              {{ call.longestWait }}
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </ng-container>
</div>
